import { Checkbox, CheckboxProps } from '@mui/material';
import { green } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';

import { LiveCheckRendererProps } from './types';

const GreenCheckbox = styled((props: CheckboxProps) => (
  <Checkbox color="default" {...props} />
))({
  color: green.A200,
  '&.Mui-checked': {
    color: green.A400,
  },
});

export const LiveCheckRenderer: React.FC<LiveCheckRendererProps> = ({
  value = false,
  handleClick,
}: LiveCheckRendererProps) => {
  const [checked, setChecked] = useState(value);

  const handleCheckboxClicked = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      handleClick();
    }
  };

  return <GreenCheckbox checked={checked} onChange={handleCheckboxClicked} />;
};
